<template>
    <flex-element :element-type="elementType" class="f-break-words" :tag="tag">
        {{ singleLineText }}
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-dumb';
import FlexElement from '@/flex-element/flex-element-dumb';

export default {
    name: 'a-heading',
    components: { FlexElement },
    mixins: [baseAtom],

    props: {
        singleLineText: {
            type: String,
            default: '',
        },

        tag: {
            type: String,
            default: '',
        },
    },
};
</script>
